<template>
  <div class="">
    <!-- 导航栏 -->
    <Header :title="$t('T_DISCLAIMER_TITLE')" link=""></Header>
    <!-- 选择框 -->
    <div class="appContent">
      <div class="notes">
        <ul>
          <li v-for="(item, index) in listData" :key='index'>{{$t(item.id)}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/header'
export default {
  name: 'notes',
  data () {
    return {
      array: [
        { id: 'T_DISCLAIMER_1' },
        { id: 'T_DISCLAIMER_2' },
        { id: 'T_DISCLAIMER_3' },
        { id: 'T_DISCLAIMER_4' }
      ],
      arrayOutOfSpec: [{ id: 'T_OUT_OF_SPEC_MODE_REPORT' }]

    }
  },
  computed: {
    ...mapState(['isOutOfSpec']),

    listData () {
      return this.isOutOfSpec ? this.arrayOutOfSpec : this.array
    }
  },
  methods: {

  },
  created () {

  },
  components: {
    Header
  }
}
</script>

<style scoped>
ul li{
  list-style: disc;
  color: #666;
  margin-bottom: 23px;
  font-size: 14px
}
</style>
